<template>
    <div>
        <v-tabs
            :value="selectedTabNumber"
            grow
            class="tabs-container"
            hide-slider
            active-class="selected-tab"
            @change="changeTab"
        >
            <v-tab v-for="tab in tabs" :key="tab.name" class="tab-container">
                {{ tab.label }}
            </v-tab>
        </v-tabs>

        <v-tabs-items :value="selectedTabNumber" :continuous="false">
            <v-tab-item class="tab-item-container">
                <v-row>
                    <v-col>
                        <search-panorama-convention-filters
                            v-model="conventionFilters"
                            :subjects="subjects"
                        />
                    </v-col>
                </v-row>
            </v-tab-item>
            <v-tab-item class="tab-item-container">
                <v-row>
                    <v-col>
                        <search-panorama-annotations-filters
                            v-model="annotationFilters"
                            :insurers="insurers"
                            :annotationOptions="annotationOptions"
                            :displayedSubjectsByType="displayedSubjectsByType"
                        />
                    </v-col>
                </v-row>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
import SearchPanoramaAnnotationsFilters from "./SearchPanoramaAnnotationsFilters.vue";
import SearchPanoramaConventionFilters from "./SearchPanoramaConventionFilters.vue";

export default {
    props: [
        "value",
        "apenafs",
        "insurers",
        "annotationOptions",
        "displayedSubjectsByType",
        "subjects",
        "selectedTab",
    ],
    components: {
        SearchPanoramaAnnotationsFilters,
        SearchPanoramaConventionFilters,
    },
    data() {
        return {
            conventionFilters: this.value.conventionFilters,
            annotationFilters: this.value.annotationFilters,
            tabs: [
                { name: "convention", label: "Par absence de dispositions" },
                { name: "annotation", label: "Par organisme et garantie" },
            ],
        };
    },
    computed: {
        selectedTabNumber() {
            return this.tabs.findIndex(tab => tab.name === this.selectedTab);
        },
    },
    methods: {
        updateFilters() {
            this.$emit("input", {
                conventionFilters: this.conventionFilters,
                annotationFilters: this.annotationFilters,
            });
        },
        changeTab(selectedTabNumber) {
            const selectedTab = this.tabs[selectedTabNumber].name;
            this.$emit("change-tab", selectedTab);
        },
    },
    watch: {
        annotationFilters: {
            handler() {
                this.updateFilters();
            },
            deep: true,
        },
        conventionFilters: {
            handler() {
                this.updateFilters();
            },
            deep: true,
        },
    },
};
</script>

<style scoped lang="sass">

.tab-container
    border: 1px solid #eceff2
    overflow: hidden
    &:not(.selected-tab)
        background-color: #eceff2
    &.selected-tab
        border-bottom: none

.selected-tab
    border-top: 2px solid #0052FF
    transition: border-top 0.25s ease

.tab-item-container
    min-height: 185px
</style>
